import { render, staticRenderFns } from "./WebsiteCard.vue?vue&type=template&id=5a381b5a&scoped=true"
import script from "./WebsiteCard.vue?vue&type=script&lang=js"
export * from "./WebsiteCard.vue?vue&type=script&lang=js"
import style0 from "./WebsiteCard.vue?vue&type=style&index=0&id=5a381b5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a381b5a",
  null
  
)

export default component.exports